import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumbs = ({ items = [] }) => {
  const navigate = useNavigate();

  if (!items || items?.length === 0) {
    return null;
  }

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      {items?.map((item, index) => {
        const isLast = index === items?.length - 1;

        return (
          <React.Fragment key={index}>
            <div
              className={`breadcrumb-item ${isLast ? 'active' : ''}`}
              onClick={() => !isLast && handleNavigation(item?.path)}
              role={!isLast ? 'button' : undefined}
              tabIndex={!isLast ? 0 : undefined}
              onKeyDown={(e) => {
                if (!isLast && (e?.key === 'Enter' || e?.key === ' ')) {
                  handleNavigation(item?.path);
                }
              }}
              style={{ cursor: !isLast ? 'pointer' : 'default' }}
            >
              {item?.icon && <Icon name={item?.icon} size={16} />}
              <span>{item?.label}</span>
            </div>
            {!isLast && (
              <Icon
                name="ChevronRight"
                size={16}
                className="breadcrumb-separator"
              />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;